import React, { useEffect } from 'react';

import { Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';

import {
    ReactHookFormIntlNumberInput,
    ReactHookFormToggleButtonGroupV2,
} from 'common/components/form';

import { handleOnBlurField } from '../helpers';

const ToggleFields = ({
    control,
    defaultValue,
    disabled,
    name,
    setValue,
    values,
}) => {
    const type = useWatch({ control, name });

    const options = Object.keys(values).map((key) => ({
        ...values[key],
        value: key,
    }));

    const field = values?.[type] || null;

    useEffect(() => {
        if (!defaultValue || !name || !setValue || type) return;
        setValue(name, defaultValue);
    }, [defaultValue, name, setValue, type]);

    return (
        <Grid container sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Grid size={{ md: 'grow', xs: 18 }}>
                <ReactHookFormToggleButtonGroupV2
                    control={control}
                    disabled={disabled}
                    fullWidth
                    name={name}
                    options={options}
                />
            </Grid>

            <Grid size={{ sm: 'grow', xs: 18 }}>
                {field && (
                    <ReactHookFormIntlNumberInput
                        append={field.append}
                        control={control}
                        disabled={disabled}
                        fullWidth
                        key={`${name}_${type}`}
                        label={field.label}
                        name={field.name}
                        onBlur={({ value }) =>
                            handleOnBlurField({
                                name: field.name,
                                setValue,
                                value,
                            })
                        }
                    />
                )}
            </Grid>
        </Grid>
    );
};

ToggleFields.propTypes = {
    control: PropTypes.object,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    setValue: PropTypes.func,
    values: PropTypes.object,
};

export default ToggleFields;
